import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

import styles from './nav.module.scss';

const NavActions = ({ children, ...props }) => (
  <div
    className={cn(styles.navActions, applyClasses(props, styles))}
    {...applyProps(props)}
  >
    {children}
  </div>
);

NavActions.propTypes = {
  /** The Nav Sub-components making up the nav */
  children: PropTypes.any,
  /** A style object forwarded to the main nav component */
  style: PropTypes.any,
  /** A class name forwarded to the main nav component */
  className: PropTypes.string,
};

NavActions.defaultProps = {
  children: undefined,
  style: undefined,
  className: undefined,
};

export default NavActions;
